import { render } from "./MentionsLegalesResultat.vue?vue&type=template&id=0cc25054&scoped=true&ts=true"
import script from "./MentionsLegalesResultat.vue?vue&type=script&lang=ts"
export * from "./MentionsLegalesResultat.vue?vue&type=script&lang=ts"

import "./MentionsLegalesResultat.vue?vue&type=style&index=0&id=0cc25054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc25054"]])

export default __exports__